import React from 'react';
import { ClinicalBarChart, ClinicalDoughnutChart } from '../../head-doctor/reports/charts/ClinicalCharts';

export function PharmacyChartCard({ title, subtitle, height = 280, children, className = '' }) {
  return (
    <article className={`cp-alert-chart-card ${className}`.trim()}>
      <header className="cp-alert-chart-card__head">
        <h3 className="cp-alert-chart-card__title">{title}</h3>
        {subtitle ? <p className="cp-alert-chart-card__subtitle">{subtitle}</p> : null}
      </header>
      <div className="cp-alert-chart-card__body" style={{ height }}>
        {children}
      </div>
    </article>
  );
}

export function PharmacyAlertsDoughnut({ data, cutout = '58%', options = {}, plugins = [] }) {
  if (!data) {
    return <p className="cp-alert-chart-empty">Aucune donnée à afficher.</p>;
  }
  return (
    <ClinicalDoughnutChart data={data} cutout={cutout} options={options} plugins={plugins} />
  );
}

export function PharmacyAlertsBar({ data, yLabel, xLabel, options = {}, horizontal = false, plugins = [] }) {
  if (!data) {
    return <p className="cp-alert-chart-empty">Aucune donnée à afficher.</p>;
  }
  return (
    <ClinicalBarChart
      data={data}
      horizontal={horizontal}
      yLabel={yLabel}
      xLabel={xLabel}
      showLegend={false}
      options={options}
      plugins={plugins}
    />
  );
}
